import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { TPVServices } from "../../../services";

/**
 * Component para la generacion de la lista agrupada de tickets en el tpv ademas de su opcion
 * de count, no count y delete
 */

@Component({
  selector: 'tpv-ticket-show-list-details',
  templateUrl: 'tpv-ticket-show-list-details.html',
})
export class TpvTicketShowListDetailsPage {
  @Input() selected_list: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public tpvServices: TPVServices) {
    this.globals.GAtrackView('TPV', 'TPV - Details - List', this.globals.restaurant.email, 'View', 'List TPV details', 'TPV', '');
  }

  onBack() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-show-list-details/tpv-ticket-show-list-details.ts